import { HttpClient } from '@angular/common/http';
import 'jquery';
import * as L from 'leaflet';
import moment from 'moment';
import { BgsLeafletComponent } from '../bgsLeaflet.component';
import { FeatureDisplayItem } from '../featureDisplay/featureDisplayItem';
import { PaginatedFeatures } from '../featureDisplay/paginatedFeatures';
import { PopupCloseHeader } from '../featureDisplay/popupCloseHeader';
import { MapLayer } from '../layers/mapLayer.abstract';

export class LayerClickManager {
  protected leafletMapObj: L.Map;
  protected http: HttpClient;

  protected currentPopup: null | L.Popup;

  public init(leafletMapObj: L.Map, http: HttpClient): this {
    this.leafletMapObj = leafletMapObj;
    this.http = http;
    return this;
  }

  public click(clickEvent: L.LeafletMouseEvent, bgsLeaflet: BgsLeafletComponent): void {
    if (!this.leafletMapObj) {
      console.warn('"init" method needs calling before "click" method!');
    }
    const itemsPromise = new Promise<Array<FeatureDisplayItem>>((resolve) => {
      // ensure taken out of flow
      setTimeout(() => {
        const promiseArray = new Array<Promise<Array<FeatureDisplayItem>>>();
        // reverse to make top layer features appear first
        bgsLeaflet
          .getLayers()
          .slice()
          .reverse()
          .forEach((layer: MapLayer) => {
            if (!layer.hidden.get()) {
              layer.click(clickEvent);

              promiseArray.push(layer.getLayerClickFeatureItem(clickEvent, this.http));
            }
          });
        resolve(
          Promise.all(promiseArray).then((featureItemArrayArray: Array<Array<FeatureDisplayItem>>) => {
            // merge arrays to single array
            return new Array<FeatureDisplayItem>().concat(...featureItemArrayArray);
          }),
        );
      });
    });

    this.displayFeatures(itemsPromise, [clickEvent.latlng.lat, clickEvent.latlng.lng]);
  }

  /**
   * Override to use the FeatureDisplayItems in a way other than using the leaflet popup.
   * You could use the PaginatedFeatures like this default implementation does.
   * @param featureItemsPromise A Promise of an array of FeatureDisplayItems.
   */
  public displayFeatures(featureItemsPromise: Promise<Array<FeatureDisplayItem>>, latLng: [number, number]): void {
    const popup = this.createPopup(latLng);
    // console.debug('createPopup', popup);

    void new PaginatedFeatures(this.leafletMapObj, featureItemsPromise)
      .getDisplayItem()
      .then((content: HTMLElement) => {
        // console.debug('content', content);
        if (null == content) {
          this.cancelPopup(popup);
        } else {
          this.showPopup(popup, content);
        }
      });
  }

  protected setPopupContent(popup: L.Popup, content: HTMLElement): void {
    popup.setContent(
      PopupCloseHeader.addToContentElement(content, () => {
        this.cancelPopup(popup);
      }),
    );
  }
  protected createPopup(latLng: [number, number]): L.Popup {
    const popup = L.popup({
      className: PaginatedFeatures.WRAPPER_CSS_CLASS,
    }).setLatLng(latLng);
    // show loading element
    this.setPopupContent(
      popup,
      jQuery(
        `<div class="${PaginatedFeatures.CSS_CLASS} loading"><i class="spinner fas fa-spinner fa-pulse"></i></div>`,
      )[0],
    );

    this.currentPopup = popup;

    // small delay on showing the popup so that if the data is available
    // but there is nothing to show, not even the loading is displayed
    setTimeout(() => {
      this.showPopup(popup);
    }, 250);

    return popup;
  }

  protected showPopup(popup: L.Popup, newContent?: HTMLElement): void {
    // only if it's the current one
    if (popup === this.currentPopup) {
      if (null != newContent) {
        this.setPopupContent(popup, newContent);
      }
      if (!popup.isOpen()) {
         
        popup['openedAt'] = moment();
        popup.openOn(this.leafletMapObj);
      }
    }
  }
  protected cancelPopup(popup: L.Popup): void {
    // console.debug('cancelPopup', popup);
    if (popup === this.currentPopup) {
      this.currentPopup = null;
      if (popup.isOpen()) {
        // close the popup after a delay if it's not been visible for long, so that it doesn't just flash up
         
        const openedAt = popup['openedAt'];
        const minDisplayMs = 500;
        const timoutMs = Math.min(minDisplayMs - moment().diff(openedAt), minDisplayMs);
        setTimeout(() => {
          this.leafletMapObj.closePopup(popup);
        }, timoutMs);
      }
    }
  }
}
